import type { PublicFaqCategory } from "@/types/faq";

/**
 * Stranice na kojima FAQ kategorija smije izaći. Kategorija nosi skup
 * placementa (kolona `faq_categories.placements`, CSV), pa isto pitanje može
 * stajati na više stranica bez dupliranja. Prazan skup znači "nigdje" — to je
 * legitimno stanje (kategorija u pripremi), ne greška.
 */
export const FAQ_PLACEMENTS = ["home", "therapists", "companies"] as const;
export type FaqPlacement = (typeof FAQ_PLACEMENTS)[number];

const VALID = new Set<string>(FAQ_PLACEMENTS);

export function isFaqPlacement(value: unknown): value is FaqPlacement {
  return typeof value === "string" && VALID.has(value);
}

/**
 * CSV iz baze -> skup placementa. Nepoznati ključevi se tiho odbacuju: baza je
 * TEXT bez CHECK-a, pa red pisan van aplikacije ne smije srušiti javnu stranicu.
 * Duplikati se sažimaju, redoslijed prati FAQ_PLACEMENTS da prikaz bude stabilan.
 */
export function parsePlacements(raw: string | null | undefined): FaqPlacement[] {
  if (!raw) return [];
  const found = new Set(raw.split(",").map((p) => p.trim()));
  return FAQ_PLACEMENTS.filter((p) => found.has(p));
}

/** Skup placementa -> CSV za upis. Normalizuje isto kao parsePlacements. */
export function serializePlacements(placements: readonly string[]): string {
  const found = new Set(placements.map((p) => p.trim()));
  return FAQ_PLACEMENTS.filter((p) => found.has(p)).join(",");
}

/** Kategorije koje se prikazuju na datoj stranici, u zatečenom redoslijedu. */
export function filterFaqCategories(
  categories: readonly PublicFaqCategory[],
  placement: FaqPlacement,
): PublicFaqCategory[] {
  return categories.filter((category) => category.placements.includes(placement));
}
